<button class="copy-to-clipboard" (click)="copyToClipboard()" ngbTooltip="Copy to clipboard" container="body">
    <img src="/assets/copy.svg" height="20">
    @if (copyStatus) {
        <span class="copy-status" [innerHTML]="copyStatus"></span>
    }
</button>
